<template>
    <BasicLayout :left='left' :middle='middle' :right='right'>
        <template v-slot:right_view>
            <div class="h-system-hide-upload" id='dropTarget'>
                <ejs-uploader ref="uploadObj" id='uploadObj' name="uploadObj" dropArea='.control-fluid' 
                   :multiple='false' :autoUpload='false' :selected="onSelect" maxFileSize=1048576000 ></ejs-uploader>
            </div>
            <div>
                <verlib-list :update='true' :hasBorder='false' :click='click' ref='list' :showToast='showToast'>
                </verlib-list>
            </div>
        </template>
    </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import VerlibList from '../../components/software/VerlibList';
import CustomDialog from '../../components/common/CustomDialog'; 
import { isNullOrUndefined } from "@syncfusion/ej2-base";
export default {
    components:{
        BasicLayout,
        VerlibList,
    },
    data() {
        return{
            left: { show: false, name: '' },
            middle: { show: false, name: '' },
            right: { show: true, crumb: this.$t('Software.softManage_Lib')},
            data:[],
        }
    },
    mounted() {
    },
    methods: {
        onSelect(args) {
            let config = {
                headers: {
                    "Content-Type": "application/json"
                }
            };
            let para = document.getElementById("uploadObj").files[0].name;
            console.log('document.getElementById("uploadObj").files[0].name',document.getElementById("uploadObj").files[0].name)
            this.axios.post("/lte/ems/verlib_new/checkFile", para, config).then(response => {
                console.log('response',response)
                if(response.status == 200)
                {
                    if(response.data.errorCode == 'SUCCESS')
                    {
                        this.upload();
                    }
                    else {
                        this.showToast('error',response.data.errorString);
                    }
                }
                this.clearSeletct(); 
            });
        },
        upload()
        {
            let file = document.getElementById("uploadObj").files[0]
            let formdata = new FormData();
            let config = {
                timeout: 30* 60 * 1000,
            }
            formdata.append('swPkgFile',file)
            this.$loading.showLoadding(this.$t('Software.Uploading'), file.name);
            this.axios.post("/lte/ems/verlib_new/addVersionAction", formdata, config).then(response => {
                this.$loading.hideLoadding();
                console.log("onSelect", response);
                if(response.status == 200)
                {
                    if(response.data.errorCode == 'SUCCESS')
                    {
                        this.showToast('success', `${this.$t('Common.tips.success')}`);
                    }
                    else
                    {
                        this.showToast('error',response.data.errorString);
                    }
                }
                else
                {
                    this.showToast('error', `${this.$t('Common.tips.failure')}`);
                }
                this.$refs.list.queryMethod();
            });
        },
        clearSeletct(){
            this.$refs.uploadObj.$el.value = '';
            this.$refs.uploadObj.filesDetails=[];
            this.$refs.uploadObj.filesList=[];
        },
        onFileUpload(args) {
            args.customFormData = [{'systemId': '1'}];
        },
        click(){
            document
                .getElementsByClassName("e-file-select-wrap")[0]
                .querySelector("button")
                .click();
            return false;
        },
        cancel() {
            this.$refs.upLoaderdialog.clear();
            this.$refs.upLoaderdialog.close();
        },
        showToast(type, content)
        {
            this.$parent.showToast(type,content);
        }
    }   
}
</script>>

<style scoped>
    .e-upload-actions {
        display: none;
    }
</style>
